import { registerPlugin } from '@capacitor/core';

export interface ReceiptRefreshPlugin {
  refreshReceipt(): Promise<{ success: boolean }>;
  getAppReceipt(): Promise<{ receipt: string }>;
}

const ReceiptRefresh = registerPlugin<ReceiptRefreshPlugin>('ReceiptRefresh', {
  web: () => import('./receiptRefreshWeb').then(m => new m.ReceiptRefreshWeb()),
});

export default ReceiptRefresh;
